import React from "react";

const AvailableColorsIcon = () => {
  return (
    <svg
      className="available-colors-icon"
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 6C10.9945 6 11.4778 6.14662 11.8889 6.42133C12.3 6.69603 12.6205 7.08648 12.8097 7.54329C12.9989 8.00011 13.0484 8.50277 12.952 8.98773C12.8555 9.47268 12.6174 9.91814 12.2678 10.2678C11.9181 10.6174 11.4727 10.8555 10.9877 10.952C10.5028 11.0484 10.0001 10.9989 9.54329 10.8097C9.08648 10.6205 8.69603 10.3 8.42133 9.88893C8.14662 9.4778 8 8.99445 8 8.5C8 7.83696 8.26339 7.20107 8.73223 6.73223C9.20107 6.26339 9.83696 6 10.5 6Z"
        fill="#1999D8"
      />
      <path
        d="M2.5 6C2.99445 6 3.4778 6.14662 3.88893 6.42133C4.30005 6.69603 4.62048 7.08648 4.8097 7.54329C4.99892 8.00011 5.04843 8.50277 4.95196 8.98773C4.8555 9.47268 4.6174 9.91814 4.26777 10.2678C3.91814 10.6174 3.47268 10.8555 2.98773 10.952C2.50277 11.0484 2.00011 10.9989 1.54329 10.8097C1.08648 10.6205 0.69603 10.3 0.421326 9.88893C0.146622 9.4778 0 8.99445 0 8.5C0 7.83696 0.263392 7.20107 0.732233 6.73223C1.20107 6.26339 1.83696 6 2.5 6Z"
        fill="#E83A39"
      />
      <path
        d="M6.5 0C6.99445 0 7.4778 0.146622 7.88893 0.421326C8.30005 0.69603 8.62048 1.08648 8.8097 1.54329C8.99892 2.00011 9.04843 2.50277 8.95196 2.98773C8.8555 3.47268 8.6174 3.91814 8.26777 4.26777C7.91814 4.6174 7.47268 4.8555 6.98773 4.95196C6.50277 5.04843 6.00011 4.99892 5.54329 4.8097C5.08648 4.62048 4.69603 4.30005 4.42133 3.88893C4.14662 3.4778 4 2.99445 4 2.5C4 1.83696 4.26339 1.20107 4.73223 0.732233C5.20107 0.263392 5.83696 0 6.5 0Z"
        fill="#8EC534"
      />
    </svg>
  );
};

export default AvailableColorsIcon;
